import { Palette, Scale, Hourglass, Users } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const aspekte = [
  {
    icon: Palette,
    title: "Börsenunabhängiger Sachwert",
    text: "Kunst entwickelt sich weitgehend unabhängig von Aktien- und Zinsmärkten — ein stabiler Anker in volatilen Zeiten.",
  },
  {
    icon: Hourglass,
    title: "Steuerfreier Verkauf nach Haltefrist",
    text: "Als privates Veräußerungsgeschäft kann der Verkauf von Kunst nach Ablauf der einjährigen Haltefrist steuerfrei erfolgen.",
  },
  {
    icon: Scale,
    title: "Kauf, Haltung & Verkauf",
    text: "Von der Umsatzsteuer beim Erwerb bis zur Bewertung im Nachlass: Wir ordnen die steuerlichen Aspekte jeder Phase ein.",
  },
  {
    icon: Users,
    title: "Generationenvermögen",
    text: "Kunst eignet sich als bausteinübergreifende Strategie zur erbschaftsteuerlich optimierten Vermögensnachfolge.",
  },
];

export const ChapterKunst = () => (
  <section id="kunst" data-testid="chapter-fine-art" className="relative bg-petrol py-24 lg:py-36 overflow-hidden">
    <p className="pointer-events-none absolute -top-10 right-0 font-display text-[16rem] leading-none font-extralight text-white/5 select-none" aria-hidden="true">03</p>
    <div className="relative mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-end">
        <div className="lg:col-span-7">
          <Reveal>
            <p className="eyebrow !text-gold">Kapitel 03</p>
            <p className="font-display text-lg italic text-gold mt-2 mb-4">Das schöne Investment</p>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-paper">
              Kunst & alternative Sachwerte
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-sage/90">
              Ästhetik trifft Strategie: Kunst ist ein greifbarer, mobiler
              Sachwert mit eigener Wertlogik — und bietet bei Kauf, Haltung
              und Verkauf bemerkenswerte steuerliche Gestaltungsspielräume.
            </p>
          </Reveal>
        </div>
        <Reveal delay={0.15} className="lg:col-span-5">
          <div className="grid grid-cols-2 gap-4">
            <img
              src="https://images.unsplash.com/photo-1632127258100-f8ae7c6c58c1?crop=entropy&cs=srgb&fm=jpg&q=85"
              alt="Kunstgalerie mit Gemälden"
              className="aspect-[3/4] w-full object-cover"
              data-testid="kunst-image-gallery"
            />
            <img
              src="https://images.unsplash.com/photo-1632127257458-4cf2eb3a42ad?crop=entropy&cs=srgb&fm=jpg&q=85"
              alt="Skulptur in einer Galerie"
              className="mt-8 aspect-[3/4] w-full object-cover"
              data-testid="kunst-image-sculpture"
            />
          </div>
        </Reveal>
      </div>

      <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10" data-testid="kunst-aspekte">
        {aspekte.map((a, i) => (
          <Reveal key={a.title} delay={i * 0.08}>
            <article className="h-full bg-petrol p-8 transition-colors duration-300 hover:bg-petrol-dark" data-testid={`kunst-aspekt-${i}`}>
              <a.icon size={22} className="text-gold" />
              <h3 className="mt-5 font-display text-lg font-medium text-paper">{a.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-sage/80">{a.text}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
